import { useState, useEffect } from 'react';

interface ViewPortSize {
  width: number;
  height: number;
}

interface ViewPortBreakpoints {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLargeDesktop: boolean;
}

export const useViewPort = () => {
  const [viewPort, setViewPort] = useState<ViewPortSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setViewPort({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const breakpoints: ViewPortBreakpoints = {
    isMobile: viewPort.width < 768,
    isTablet: viewPort.width >= 768 && viewPort.width < 1024,
    isDesktop: viewPort.width >= 1024 && viewPort.width < 1440,
    isLargeDesktop: viewPort.width >= 1440,
  };

  return {
    ...viewPort,
    ...breakpoints,
  };
};